module.exports = __webpack_public_path__ + "static/mob_logo-534d68dd3ba429d4b982996808322a14.png";